import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IInterviewRequestCancelClickedPayload {
  postingId: string;
}

/**
 * Fires when user clicks "Cancel" on the interview request page
 * Event: dental_portal:interview_request:cancel_clicked
 */
export function fireInterviewRequestCancelClicked(
  payload: IInterviewRequestCancelClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:interview_request:cancel_clicked', {
    posting_id: payload.postingId,
  });
}